// @flow
import React from 'react';
import styled from 'styled-components';
import type Step from 'models/Step';
import * as Layout from 'styles/Layout';

const StepContainer = styled(Layout.FlexRow)`
  position: relative;
  justify-content: center;
  align-items: center;
  height: ${props => (props.widthOption > 160 ? '60' : '45')}px;
  width: ${props => props.widthOption}px;
  background-color: #ffffff;
  border-bottom: solid 4px #e6e6e6;
  cursor: ${props => (props.disabledAction ? 'default' : 'pointer')};
`;
const StepText = styled.span`
  height: ${props => (props.isActive ? '22px' : '19px')};
  color: ${props => (props.isActive ? '#278C7E' : '#CACACA')};
  font-size: ${props => (props.isActive ? '16px' : '16px')};
  font-weight: ${props => (props.isActive && props.instep ? 'bold' : '500')};
  line-height: ${props => (props.isActive ? '22px' : '19px')};
  transition: all 0.1s linear;
`;

const StepActiveDecor = styled.div`
  position: absolute;
  display: block;
  bottom: -4px;
  left: 0;
  height: ${props => (props.isActive && props.instep ? '4px' : '2px')};
  width: 100%;
  opacity: ${props => (props.isActive ? '1' : '0')};
  border-radius: ${props => (props.isCurrent ? '0 10px 10px 0' : '0')};
  background-color: #278c7e;
  transition: all 0.1s linear;
`;

type PropsType = {
  step: Step,
  isActive: boolean,
  isCurrent: boolean,
  disabledAction: boolean,
  widthOption: number,
  instep?: boolean,
  id?: string,
  linkTo?: string,
  linkToInTabs: (value: any) => void,
  optionSize: number
};

export default class StepComponent extends React.Component<PropsType> {
  constructor(props: PropsType) {
    super(props);
  }

  linkToInTabs = (): void => {
    if (!this.props.disabledAction) this.props.linkToInTabs(this.props.linkTo);
  };

  setScrollInStep = (): void => {
    var x = window.matchMedia('(max-width: 700px)');
    if (x.matches) {
      const { instep, linkTo, optionSize } = this.props;
      if (instep) {
        const widthStep = document.getElementById('scrollx')
          ? document.getElementById('scrollx').scrollWidth / optionSize
          : 0;
        const positionScroll = widthStep - widthStep / 2;
        const scrollP = widthStep * linkTo - positionScroll;
        if (document.getElementById('scrollx'))
          document.getElementById('scrollx').scrollTo({
            left: scrollP,
            behavior: 'smooth'
          });
      }
    }
  };

  render() {
    this.setScrollInStep();
    const {
      widthOption,
      step,
      isActive,
      isCurrent,
      disabledAction,
      instep
    } = this.props;
    return (
      <StepContainer
        onClick={this.linkToInTabs}
        widthOption={parseInt(widthOption)}
        disabledAction={disabledAction}
      >
        <StepText instep={instep} isActive={isActive}>
          {step.name}
        </StepText>
        <StepActiveDecor
          instep={instep}
          isActive={isActive}
          isCurrent={isCurrent}
        />
      </StepContainer>
    );
  }
}
